<div #contentWrapper>
    <ng-content></ng-content>
</div>
<label [ngClass]="{ 'hide-input-wrapper': hasProjectedContent }" class="custom-file-upload">
    <input
        #fileInput
        class="media-upload-button"
        type="file"
        [multiple]="allowMultiple"
        (change)="prepareFiles($event)"
        [disabled]="saving | async"
        [accept]="allowedMimeType.join(',')"
        data-testid="media-upload-file-input"
    />
    <mat-icon class="item-icon">cloud_upload</mat-icon>
    <span fxFlex="grow" class="tool-button-text"> {{ uploadBtnLabel }} </span>
    <mat-icon class="qs-m" [matTooltip]="uploadBtnTooltip">question_mark</mat-icon>
</label>
